import { Injectable } from '@angular/core';
import {
  RemoveLevel3LevelName,
  SetLevel3LevelName,
} from '../store/filter-level3Name.state';
import {
  RemoveLevel2LevelName,
  SetLevel2LevelName,
} from '../store/filter-level2Name.state';
import {
  RemoveLevel1LevelName,
  SetLevel1LevelName,
} from '../store/filter-level1Name.state';
import { Store } from '@ngxs/store';
import { HeirarchyFilterServiceService } from '../../shared/service/heirarchy-filter-service/heirarchy-filter-service.service';
import { SetLevel1State } from '../store/filter-level1.state';
import { SetLevel2State } from '../store/filter-level2.state';
import { SetLevel3State } from '../store/filter-level3.state';
import { SetSegmentTypeState } from '../store/filter-segmenttype.state';
import { SetSegmentModel } from '../store/filter-segments';
import { SetAssetTypeModel } from '../store/filter-assettype';
import { SetSurveyRouteModel } from '../store/filter-serveyrotes';

@Injectable({ providedIn: 'root' })
export class LevelNameService {
  constructor(
    private hierarchyService: HeirarchyFilterServiceService,
    private store: Store,
  ) {}

  async generateLevelNames(): Promise<void> {
    await this.hierarchyService.initialize();
    this.store.dispatch(new RemoveLevel1LevelName());
    this.store.dispatch(new RemoveLevel2LevelName());
    this.store.dispatch(new RemoveLevel3LevelName());

    const levelNameList =
      await this.hierarchyService.getLevelNamesByPrimaryComapany('');
    if (levelNameList?.items) {
      levelNameList.items.forEach((item) => {
        if (item?.level1Name != null) {
          this.store.dispatch(new SetLevel1LevelName(item.level1Name));
        }
        if (item?.level2Name != null) {
          this.store.dispatch(new SetLevel2LevelName(item.level2Name));
        }
        if (item?.level3Name != null) {
          this.store.dispatch(new SetLevel3LevelName(item.level3Name));
        }
      });
    }
  }

  clearAllFilterAndStores(): void {
    this.store.dispatch(new SetLevel1State([]));
    this.store.dispatch(new SetLevel2State([]));
    this.store.dispatch(new SetLevel3State([]));
    this.store.dispatch(new SetSegmentTypeState([]));
    this.store.dispatch(new SetSegmentModel([]));
    this.store.dispatch(new SetAssetTypeModel([]));
    this.store.dispatch(new SetSurveyRouteModel([]));
  }
}
